import PrivacyPolicy_v1 from '../list/PrivacyPolicy_v1';
import PrivacyPolicy_v2 from '../list/PrivacyPolicy_v2';
import PrivacyPolicy_v3 from '../list/PrivacyPolicy_v3';
import PrivacyPolicy_v4 from '../list/PrivacyPolicy_v4';
import PrivacyPolicy_v5 from '../list/PrivacyPolicy_v5';
import PrivacyPolicy_v6 from '../list/PrivacyPolicy_v6';
import PrivacyPolicy_v7 from '../list/PrivacyPolicy_v7';
import PrivacyPolicy_v8 from '../list/PrivacyPolicy_v8';
import PrivacyPolicy_v9 from '../list/PrivacyPolicy_v9';
import PrivacyPolicy_v10 from '../list/PrivacyPolicy_v10';
import PrivacyPolicy_v11 from '../list/PrivacyPolicy_v11';
import PrivacyPolicy_v12 from '../list/PrivacyPolicy_v12';
import PrivacyPolicy_v13 from '../list/PrivacyPolicy_v13';
import PrivacyPolicy_v14 from '../list/PrivacyPolicy_v14';
import PrivacyPolicy_v15 from '../list/PrivacyPolicy_v15';
import PrivacyPolicy_v16 from '../list/PrivacyPolicy_v16';
import PrivacyPolicy_v17 from '../list/PrivacyPolicy_v17';
import PrivacyPolicy_v18 from '../list/PrivacyPolicy_v18';
import PrivacyPolicy_v19 from '../list/PrivacyPolicy_v19';
import PrivacyPolicy_v20 from '../list/PrivacyPolicy_v20';
import PrivacyPolicy_v21 from '../list/PrivacyPolicy_v21';
import PrivacyPolicy_v22 from '../list/PrivacyPolicy_v22';
import PrivacyPolicy_v23 from '../list/PrivacyPolicy_v23';
import PrivacyPolicy_v24 from '../list/PrivacyPolicy_v24';
import PrivacyPolicy_v25 from '../list/PrivacyPolicy_v25';
import PrivacyPolicy_v26 from '../list/PrivacyPolicy_v26';
import PrivacyPolicy_v27 from '../list/PrivacyPolicy_v27';
import PrivacyPolicy_v28 from '../list/PrivacyPolicy_v28';
import PrivacyPolicy_v29 from '../list/PrivacyPolicy_v29';

interface privacyPolicyComponentsType {
  [key: string]: () => JSX.Element;
}
export const privacyPolicyComponents: privacyPolicyComponentsType = {
  '2023년 04월 12일': PrivacyPolicy_v29,
  '2023년 01월 02일': PrivacyPolicy_v28,
  '2022년 11월 10일': PrivacyPolicy_v27,
  '2022년 10월 18일': PrivacyPolicy_v26,
  '2022년 9월 16일': PrivacyPolicy_v25,
  '2022년 9월 1일': PrivacyPolicy_v24,
  '2022년 8월 4일': PrivacyPolicy_v23,
  '2022년 6월 29일': PrivacyPolicy_v22,
  '2022년 1월 18일': PrivacyPolicy_v21,
  '2021년 11월 1일': PrivacyPolicy_v20,
  '2021년 8월 17일': PrivacyPolicy_v19,
  '2021년 6월 21일': PrivacyPolicy_v18,
  '2021년 6월 2일': PrivacyPolicy_v17,
  '2021년 5월 18일': PrivacyPolicy_v16,
  '2021년 4월 23일': PrivacyPolicy_v15,
  '2021년 4월 7일': PrivacyPolicy_v14,
  '2021년 1월 14일': PrivacyPolicy_v13,
  '2020년 12월 15일': PrivacyPolicy_v12,
  '2020년 9월 9일': PrivacyPolicy_v11,
  // '2020년 9월 9일': PrivacyPolicy_v10, 미노출
  '2020년 7월 30일(ver.2)': PrivacyPolicy_v9,
  '2020년 7월 30일(ver.1)': PrivacyPolicy_v8,
  '2020년 5월 19일': PrivacyPolicy_v7,
  '2019년 9월 11일': PrivacyPolicy_v6,
  '2019년 8월 29일': PrivacyPolicy_v5,
  '2019년 5월 13일': PrivacyPolicy_v4,
  '2019년 1월 3일': PrivacyPolicy_v3,
  '2018년 3월 19일': PrivacyPolicy_v2,
  '2016년 2월 17일': PrivacyPolicy_v1,
};
